<template>
  <app-page labelledby="route-state-page-title" data-testid="route-state-page">
    <page-header
      :title="pageTitle"
      :description="description"
      title-id="route-state-page-title"
    />

    <app-state
      :state="state"
      :title="stateTitle"
      :message="message"
      :action-label="actionLabel"
      :action-to="actionTo"
    />
  </app-page>
</template>

<script>
import AppPage from '../../components/ui/AppPage.vue'
import AppState from '../../components/ui/AppState.vue'
import PageHeader from '../../components/ui/PageHeader.vue'

export default {
  name: 'RouteStatePage',
  components: { AppPage, AppState, PageHeader },
  props: {
    state: {
      type: String,
      default: 'not-found'
    },
    pageTitle: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    stateTitle: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    actionLabel: {
      type: String,
      default: 'На главную'
    },
    actionTo: {
      type: [String, Object],
      default: () => ({ name: 'home' })
    }
  }
}
</script>
